export interface ICountry {
  id: string;
  name: string;
  active: boolean;
  currencySymbol: string;
  twoLetterISORegionName: string;
  taxDefinitions: ITaxDefinition[];
}

export interface ITaxDefinition {
  id: string;
  name: string;
  rate: number;
}
